module.exports = __webpack_public_path__ + "64d82ee3e3b97bece43f9380403337d4.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/quarantaene_rr.jpg
// module id = 673
// module chunks = 0